import React from 'react';
import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import { ActiveFilter, FilterAction } from 'proto/Search/ActiveFilter';

import Element from '../Element';

import styles from './List.module.scss';

export interface ListProps {
    activeFilterList: ActiveFilter[];
    onFilterClick?: (actionList: FilterAction[], filterIndex: number) => void;
    onResetAllClick?: () => void;
}

const List = ({
    activeFilterList,
    onFilterClick,
    onResetAllClick,
}: ListProps) => {
    const { t } = useTranslation();

    return (
        <div className={styles.List}>
            {activeFilterList?.map((activeFilter, index) => (
                <Element
                    key={index}
                    activeFilter={activeFilter}
                    onClick={() =>
                        onFilterClick?.(activeFilter.actionList, index)
                    }
                />
            ))}
            {activeFilterList.length > 0 && (
                <span
                    className={classNames(
                        styles.ListReset,
                        'js-react-reset-all-filter'
                    )}
                    onClick={onResetAllClick}
                    onKeyUp={() => {}}
                    role="link"
                    tabIndex={0}
                >
                    {t('TRANS-reset-all-filters')}
                </span>
            )}
        </div>
    );
};

export default List;
